import * as React from "react";

const QuoteRight = ({ size = '80' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    // width="80"
    // height="69"
    width={size}
    height={size * 0.8625}
    fill="none"
    viewBox="0 0 80 69"
  >
    <path
      fill="#333"
      d="M27.793 34.54H15.586v-9.767c0-5.386 4.38-9.765 9.766-9.765h1.22a3.653 3.653 0 0 0 3.662-3.662V4.022A3.653 3.653 0 0 0 26.572.359h-1.22C11.862.36.938 11.285.938 24.773v36.622a7.326 7.326 0 0 0 7.324 7.324h19.531a7.326 7.326 0 0 0 7.324-7.324V41.863a7.326 7.326 0 0 0-7.324-7.324M71.738 34.54H59.531v-9.767c0-5.386 4.38-9.765 9.766-9.765h1.22a3.653 3.653 0 0 0 3.663-3.662V4.022A3.653 3.653 0 0 0 70.517.359h-1.22c-13.489 0-24.414 10.926-24.414 24.414v36.622a7.326 7.326 0 0 0 7.324 7.324h19.531a7.326 7.326 0 0 0 7.325-7.324V41.863a7.326 7.326 0 0 0-7.325-7.324"
    ></path>
  </svg>
);

export default QuoteRight;
